import {AlertWrapper, FullOverlay, StyledDisplayLargeTypography} from "@/components/SessionTimeoutWarning.styles";
import React, {useEffect, useState} from "react";

const COUNTDOWN_TICK_MS = 500;

type Props = {
  handleStillHere: () => void;
  getRemainingTime: () => number;
  onExpire: () => void;
};

const secondsRemaining = (milliseconds: number) => Math.max(0, Math.ceil(milliseconds / 1000));

const SessionTimeoutWarning = ({handleStillHere, getRemainingTime, onExpire}: Props) => {
  const [timer, setTimer] = useState(() => secondsRemaining(getRemainingTime()));
  const minutes = Math.floor(timer / 60);
  const seconds = timer - minutes * 60;

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = secondsRemaining(getRemainingTime());
      setTimer(remaining);

      if (remaining <= 0) {
        clearInterval(interval);
        onExpire();
      }
    }, COUNTDOWN_TICK_MS);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime, onExpire]);

  useEffect(() => {
    document.body.addEventListener('click', handleStillHere);
    return () => {
      document.body.removeEventListener('click', handleStillHere);
    };
  }, [handleStillHere]);

  return (
    <>
      <FullOverlay />
      <AlertWrapper data-testid="session-timeout-wrapper">
        <StyledDisplayLargeTypography>
          SESSION TIMEOUT WARNING
        </StyledDisplayLargeTypography>
        <div>
          Your online session will expire in <strong>{minutes} minutes {seconds} seconds</strong>
        </div>
        <div>
          Please click on the screen to keep working...
        </div>
      </AlertWrapper>
    </>
  );
};

export default SessionTimeoutWarning;
